import { render, staticRenderFns } from "./SEOHead.vue?vue&type=template&id=26d6d3d8"
import script from "./SEOHead.vue?vue&type=script&lang=js"
export * from "./SEOHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports